import * as React from 'react';

import * as styles from './styles.css';

interface ISectionProps {
  children: React.ReactNode;
  dataMark?: string;
}

export function Section({ children, dataMark, ...divProps }: ISectionProps) {
  return (
    <section {...divProps} data-mark={dataMark} className={styles['section']}>
      {children}
    </section>
  );
}

Section.defaultProps = {
  padded: true,
};
